import { motion, AnimatePresence } from "framer-motion";
import { Shield, X, MessageCircle, CheckCircle } from "lucide-react";
import { useState } from "react";
import axios from "axios";
import { API } from "../App";
import { BRAND } from "../lib/brandConfig";

const CLPEngagementModal = ({ open, onClose, leadId }) => {
  const [acknowledged, setAcknowledged] = useState(false);

  const handleAcknowledge = async () => {
    setAcknowledged(true);
    if (leadId) {
      try {
        await axios.post(`${API}/clp/track`, {
          lead_id: leadId,
          event_type: "acknowledge_clp",
        });
      } catch (e) {
        console.error("CLP ack failed:", e);
      }
    }
    setTimeout(onClose, 1500);
  };

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/40"
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden"
            data-testid="clp-engagement-modal"
          >
            {/* Header accent */}
            <div className="bg-[#0A2342] px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-white" />
                <h3 className="text-white font-semibold text-base">Quick Heads Up</h3>
              </div>
              <button
                onClick={onClose}
                className="text-white/60 hover:text-white transition-colors"
                data-testid="clp-engagement-close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-6">
              {acknowledged ? (
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="text-center py-4"
                >
                  <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
                  <p className="text-[#0A2342] font-semibold">Thanks! You're all set.</p>
                </motion.div>
              ) : (
                <>
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">
                    Looks like you're finding some great options! Before you tour, just a friendly reminder:
                  </p>
                  <div className="bg-[#0A2342]/5 rounded-xl p-4 mb-5">
                    <p className="text-[#0A2342] text-sm font-medium leading-relaxed">
                      Please list <strong>{BRAND.agentAttribution}</strong> on
                      any guest cards when you tour. This lets me continue to help you at
                      <strong> no cost to you</strong>.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button
                      onClick={handleAcknowledge}
                      className="w-full py-3 bg-[#0A2342] text-white rounded-xl font-medium hover:bg-[#0A2342]/90 transition-colors text-sm"
                      data-testid="clp-acknowledge-btn"
                    >
                      Got it, I'll list Bryan Spann
                    </button>
                    <a
                      href="sms:+19362241484?body=Hi%20Bryan%2C%20I%20have%20a%20question%20about%20touring."
                      className="w-full py-3 border border-slate-200 text-slate-600 rounded-xl font-medium hover:bg-slate-50 transition-colors text-sm text-center flex items-center justify-center gap-2"
                      data-testid="clp-text-bryan-btn"
                    >
                      <MessageCircle className="w-4 h-4" /> Text Bryan a Question
                    </a>
                  </div>
                </>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default CLPEngagementModal;
